import { message } from 'antd';

import { POST, GET } from 'src/network/apiHandler';
import config from 'src/globals';
import { GET_VEHICLE_REQUEST, GET_VEHICLE_REQUEST_COUNT } from 'src/api/routes';
import {
  SET_VEHICLE_REQUEST,
  SET_VEHICLE_REQUEST_COUNT,
  SET_VEHICLE_REQUEST_LOADER,
} from 'src/common/actions/constants';
import { getVehicleRequestsCountISTApi, getVehicleRequestsISTApi } from 'src/api/VehicleRequest';

const { API_BASE_URL } = config;

export const getVehicleRequest = (data) => async (dispatch, getState) => {
  dispatch({
    type: SET_VEHICLE_REQUEST_LOADER,
    data: true,
  });
  const response = await POST(API_BASE_URL + GET_VEHICLE_REQUEST, data);
  if (response.isSuccess) {
    dispatch({
      type: SET_VEHICLE_REQUEST,
      data: response.data,
    });
  } else {
    message.error(response.errorMessage);
  }
  dispatch({
    type: SET_VEHICLE_REQUEST_LOADER,
    data: false,
  });
};

export const getVehicleRequestIST = (data) => async (dispatch, getState) => {
  dispatch({
    type: SET_VEHICLE_REQUEST_LOADER,
    data: true,
  });
  const response = await getVehicleRequestsISTApi(data);
  if (response.isSuccess) {
    dispatch({
      type: SET_VEHICLE_REQUEST,
      data: response.data,
    });
  } else {
    message.error(response.errorMessage);
  }
  dispatch({
    type: SET_VEHICLE_REQUEST_LOADER,
    data: false,
  });
};

export const getVehicleRequestCount = (data) => async (dispatch, getState) => {
  dispatch({
    type: SET_VEHICLE_REQUEST_LOADER,
    data: true,
  });
  const response = await POST(API_BASE_URL + GET_VEHICLE_REQUEST_COUNT, data);
  if (response.isSuccess) {
    dispatch({
      type: SET_VEHICLE_REQUEST_COUNT,
      data: response.data?.[0] ?? {},
    });
  } else {
    message.error(response.errorMessage);
  }
  dispatch({
    type: SET_VEHICLE_REQUEST_LOADER,
    data: false,
  });
};

export const getVehicleRequestCountIST = (data) => async (dispatch, getState) => {
  dispatch({
    type: SET_VEHICLE_REQUEST_LOADER,
    data: true,
  });
  const response = await getVehicleRequestsCountISTApi(data);
  if (response.isSuccess) {
    dispatch({
      type: SET_VEHICLE_REQUEST_COUNT,
      data: response.data?.[0] ?? {},
    });
  } else {
    message.error(response.errorMessage);
  }
  // dispatch({
  //   type: SET_VEHICLE_REQUEST_LOADER,
  //   data: false,
  // });
};
